import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { CuratedMediaList, Media } from 'models';
import { useDispatch, useSelector } from 'react-redux';
import { get_all_processedMedia } from 'features/processedMedia/processedMedia-slice';
import { useEffect, useState } from 'react';
import * as SC from 'features/shared_components';
import { styled, useTheme } from '@mui/material/styles';
import TitleService from 'title-service';
import { get_all_contentHouse } from 'features/contentHouse/contentHouse-slice';
import { get_content_houses_for_customer, get_media_for_customer } from 'features/auto-thunks';
import { getUserClaims } from 'features/application/application-slice';
import { gridSpacing } from 'store/constant';
import { Avatar, Badge, Box, Grid } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import rq from 'components/RedQuick';
import { get_all_media } from 'features/media/media-slice';
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    width: '70%',               // Set the width to 70%
    maxWidth: '800px',          // Set the maximum width to 800px
    minHeight: '80vh',         // Set the minimum height to 80% of the viewport height
    height: 'auto',            // Adjust the height based on content
    maxHeight: '100vh',        // Set the maximum height to 100% of the viewport height

    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {

        padding: theme.spacing(1),
    },
}));


export default function CoherentScreenMediaSelectionDialog({
    curatedMediaList,
    onAddProcessedMediaItems,
    onClose,
    open
}: {
    onAddProcessedMediaItems: (args: string[]) => void,
    curatedMediaList: CuratedMediaList,
    onClose: () => void,
    open: boolean
}) {
    const contentHouse_list = useSelector(get_all_contentHouse);
    const claims = useSelector(getUserClaims);
    const media_list = useSelector(get_all_media);
    const dispatch = useDispatch();
    const theme = useTheme();
    const [selectedMedia, setSelectedMedia] = useState<{ [key: string]: boolean }>({});
    const [contentHouse, setContentHouse] = useState<string>(null);
    const handleClose = () => {
        setContentHouse(null);
        setSelectedMedia({});
        onClose();
    };

    useEffect(() => {
        if (open) {
            dispatch(get_content_houses_for_customer({
                userId: claims?.user,
                customerAdministratorId: claims?.customerAdministrator
            }))
        }
    }, [open]);
    useEffect(() => {
        if (contentHouse) {
            dispatch(get_media_for_customer({
                userId: claims?.user,
                customerAdministratorId: claims?.customerAdministrator,
                owner: contentHouse
            }))
        }
    }, [contentHouse])
    useEffect(() => {
        if (curatedMediaList && open) {
            let selections: any = {};
            curatedMediaList.media.forEach((m) => {
                selections[m.id] = true
            })
            setSelectedMedia({
                ...selections,
                ...selectedMedia
            })
        }
    }, [open, curatedMediaList?.version])

    return (
        <Dialog
            open={open}
            classes={{
                root: `red-quick-scroll-dialog `
            }}
            maxWidth={'xl'}
            onClose={handleClose}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                Select Media
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Grid container spacing={gridSpacing} minHeight={560}>
                    <Grid item xs={4} sm={4} md={4} >
                        <Typography variant="h5" sx={{ m: 0 }}>
                            {TitleService('Content Houses')}
                        </Typography>
                        {SC.sharedList(
                            (contentHouse_list || []).filter(x => !x.deleted).map(item => {
                                return {
                                    ...item,
                                    selected: item?.id === contentHouse,
                                }
                            }),
                            SC.sharedListItemBuilder,
                            (item: Media) => {
                                return {
                                    name: item?.name || TitleService('Unknown'),
                                    date: item?.created || item.updated,
                                    selected: item?.id === contentHouse,
                                    statusColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
                                    getIcon: () => {
                                        return (
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-details"
                                                width="20" height="20" viewBox="0 0 24 24"
                                                strokeWidth="1.5" stroke="#597e8d" fill="none"
                                                strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M13 5h8" />
                                                <path d="M13 9h5" />
                                                <path d="M13 15h8" />
                                                <path d="M13 19h5" />
                                                <rect x="3" y="4" width="6" height="6" rx="1" />
                                                <rect x="3" y="14" width="6" height="6" rx="1" />
                                            </svg>
                                        )
                                    }
                                }
                            }, (item) => {
                                setContentHouse(item?.id);
                            })}
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} >
                        <Typography variant="h5" sx={{ m: 0 }}>
                            {TitleService('Media')}
                        </Typography>
                        {SC.sharedList(
                            (media_list || []).filter(x => !x.deleted).filter(x => x.owner === contentHouse)
                                .filter(x => !selectedMedia[x.id])
                                .map(item => {
                                    return {
                                        ...item,
                                        selected: selectedMedia[item?.id],
                                    }
                                }),
                            SC.sharedListItemBuilder,
                            (item) => {
                                return {
                                    name: item?.name || TitleService('Unknown'),
                                    date: item?.created || item.updated,
                                    statusColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
                                    getIcon: () => {
                                        let imageUrl = item.thumbnailDefaultUrl || item.thumbnail;
                                        return imageUrl ? <Box sx={{ position: 'relative' }}>
                                            <Badge
                                                overlap="circular"
                                                badgeContent={
                                                    < FiberManualRecordIcon sx={{
                                                        fontSize: '0.875rem'
                                                    }
                                                    } />
                                                }
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right'
                                                }}
                                            >
                                                <Avatar alt={item?.name} title={item?.name} src={imageUrl} />
                                            </Badge>
                                        </Box> : (
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-details"
                                                width="20" height="20" viewBox="0 0 24 24"
                                                strokeWidth="1.5" stroke="#597e8d" fill="none"
                                                strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M13 5h8" />
                                                <path d="M13 9h5" />
                                                <path d="M13 15h8" />
                                                <path d="M13 19h5" />
                                                <rect x="3" y="4" width="6" height="6" rx="1" />
                                                <rect x="3" y="14" width="6" height="6" rx="1" />
                                            </svg>
                                        )
                                    }
                                }
                            }, (item) => {
                                setSelectedMedia({
                                    ...selectedMedia,
                                    [item.id]: !selectedMedia[item.id]
                                });
                            })}
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} >
                        <Typography variant="h5" sx={{ m: 0 }}>
                            {TitleService('Selected Media')}
                        </Typography>
                        {SC.sharedList(
                            (media_list || []).filter(x => {
                                return selectedMedia[x.id];
                            }).filter(x => !x.deleted)
                                .map(item => {
                                    return {
                                        ...item,
                                        selected: selectedMedia[item?.id],
                                    }
                                }),
                            SC.sharedListItemBuilder,
                            (item) => {
                                return {
                                    name: item?.name || TitleService('Unknown'),
                                    date: item?.created || item.updated,
                                    statusColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
                                    getIcon: () => {
                                        let imageUrl = item.thumbnailDefaultUrl || item.thumbnail;
                                        return imageUrl ? <Box sx={{ position: 'relative' }}>
                                            <Badge
                                                overlap="circular"
                                                badgeContent={
                                                    < FiberManualRecordIcon sx={{
                                                        fontSize: '1.875rem'
                                                    }
                                                    } />
                                                }
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right'
                                                }}
                                            >
                                                <Avatar sizes='180px' alt={item?.name} title={item?.name} src={imageUrl} />
                                            </Badge>
                                        </Box> : (
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-list-details"
                                                width="20" height="20" viewBox="0 0 24 24"
                                                strokeWidth="1.5" stroke="#597e8d" fill="none"
                                                strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M13 5h8" />
                                                <path d="M13 9h5" />
                                                <path d="M13 15h8" />
                                                <path d="M13 19h5" />
                                                <rect x="3" y="4" width="6" height="6" rx="1" />
                                                <rect x="3" y="14" width="6" height="6" rx="1" />
                                            </svg>
                                        )
                                    }
                                }
                            }, (item) => {
                                setSelectedMedia({
                                    ...selectedMedia,
                                    [item.id]: !selectedMedia[item.id]
                                });
                            })}
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={() => {
                    onAddProcessedMediaItems(Object.keys(selectedMedia).filter(x => selectedMedia[x]))
                    handleClose();
                }}>
                    Add
                </Button>
                <Button onClick={() => {
                    handleClose();
                }}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
